export const permissionsRoutes = [
  {
    path: "/app/access-denied",
    component: () => import("./AccessDenied.vue"),
    meta: {
      routeName: window.$_t("ACCESS DENIED"),
      skipGlobalLoader: true,
    },
  },
];
